<template>
	<layout module-name="Cobranças" title="Emitir Cobrança">
		<template #page>
			<div class="page-container">
				<div class="container">
					<section-title
						title="Emitir Cobrança"
						style="margin-bottom: 25px"
					/>
					<ticket-card>
						<div class="icon-ticket">
							<div class="border-icon">
								<ui-check-icon />
							</div>
						</div>
						<div class="section-title">
							<h2 class="ticket-title">
								Cobrança <span class="ticket-number">#0001</span> gerada com
								sucesso!
							</h2>
						</div>
						<div class="section-description">
							<span class="ticket-description"
								>Enviamos o link para pagamento aos seus respectivos responsáveis
								para pagamento.</span
							>
							<span class="ticket-description"
								>Acompanhe o status da cobrança na área de gestão.</span
							>
						</div>
						<div class="section-divider negative-bottom">
							<span class="divider-title">Informações</span>
						</div>
						<div class="section-info">
							<div class="info-item">
								<span class="info-title">Negócio:</span>
								<span class="info-description">4585 - Eduardo Gomes Pereira</span>
							</div>
							<div class="info-item">
								<span class="info-title">Tipo da cobrança:</span>
								<span class="info-description">Reserva Pix</span>
							</div>
							<div class="info-item">
								<span class="info-title">Descrição:</span>
								<span class="info-description">Reserva de Unidade - Park House Residence - Quadra 03 - Lote 05</span>
							</div>
							<div class="info-item">
								<span class="info-title">Valor:</span>
								<span class="info-description">R$ 5.000,00</span>
							</div>
							<div class="info-item">
								<span class="info-title">Quantidade de Pix:</span>
								<span class="info-description">02</span>
							</div>
							<div class="info-item">
								<span class="info-title">Criado em:</span>
								<span class="info-description">10/05/2025 às 10:00</span>
							</div>
							<div class="info-item">
								<span class="info-title">Responsável:</span>
								<span class="info-description">Glauco Farnezi</span>
						</div>
						</div>
						<div class="section-divider negative-top">
							<span class="divider-title">Faturas</span>
						</div>
						<div class="payment-list">
							<payment-card
								v-for="payment in payments"
								:key="payment.id"
								:pixLabel="payment.pixLabel"
								:title="payment.title"
								:value="payment.value"
								:description="payment.description"
								:status="payment.status"
								:link="payment.link"
								:dueDate="payment.dueDate"
							>
							</payment-card>
						</div>
						<div class="section-buttons">
							<ui-button design="md primary">
								<span class="button-figma">
									Detalhes da Cobrança
								</span>
							</ui-button>
						</div>
					</ticket-card>
					<div class="page-observations">
						<h2 class="observations-description">Ao transferir uma reserva ela é será cancelada para o negócio de origem e logo após é realizado uma nova reserva para o negócio de destino.</h2>
					</div>
				</div>
			</div>
		</template>
	</layout>
</template>

<script>
	import layout from '@/templates/page-payments'
	import sectionTitle from '@/components/ui-facilita/section-title'
	import ticketCard from './components/TicketCard'
	import paymentCard from './components/PaymentCard'
	import { uiButton } from "@/components/ui/buttons";
	export default {
		name: 'payments',
		components: {
			layout,
			sectionTitle,
			ticketCard,
			paymentCard,
			uiButton
		},
		data() {
			return {
				payments:[
					{
						id: 1,
						pixLabel: 'Pix 1 - #45695',
						title: 'Pai do Eduardo',
						value: '3.000',
						description: 'Enviado para o whatsapp: +55981971555',
						status: 'paid',
						link: 'Comprovante'
					},
					{
						id: 2,
						pixLabel: 'Pix 2 - #45696',
						title: 'Mãe do Eduardo',
						value: '2.000',
						description: 'Enviado para o email: maria.pereira@gmail.com',
						status: 'pending',
						link: 'Reenviar Email',
						dueDate: '10/05/2025 às 15:00'
					}
				],
			}
		},
		methods: {},
	}
</script>

<style lang="stylus" scoped>
@import './styles.styl'
</style>
